import React, { useState } from 'react'
import InfoModal from './InfoModal'

function ServiceCard({ img_src, img_alt, card_heading, card_para, card_button, numOfCard }) {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => setIsModalVisible(true)
  const handleOk = () => setIsModalVisible(false)
  const handleCancel = () => setIsModalVisible(false)

  return (
    <>
      {img_src ? (
        <div className="sc-card">
          <div className="sc-icon">
            <img src={img_src} alt={img_alt} />
          </div>
          <h5 className="sc-heading">{card_heading}</h5>
          <p className="sc-para">{card_para}</p>
          {/* <span className="sc-learn-more">Learn more →</span> */}
        </div>
      ) : (
        <div className={`sc-card sc-card--cta ${numOfCard === 'odd' ? 'sc-card--cta-odd' : ''}`}>
          <h3 className="sc-cta-heading">{card_heading}</h3>
          <button className="sc-cta-btn" onClick={showModal}>{card_button}</button>
        </div>
      )}
      <InfoModal
        companyIsEnabled
        url="http://185.213.27.237:8066/Email/ContactUs"
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
    </>
  )
}

export default ServiceCard
